import { render, staticRenderFns } from "./WhitePageGenerate.vue?vue&type=template&id=20590a8c&scoped=true&"
import script from "./WhitePageGenerate.vue?vue&type=script&lang=js&"
export * from "./WhitePageGenerate.vue?vue&type=script&lang=js&"
import style0 from "./WhitePageGenerate.vue?vue&type=style&index=0&id=20590a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20590a8c",
  null
  
)

export default component.exports